import { createCustomAction } from 'typesafe-actions';

import { BatchesCollection } from '../BatchesList/typings';
import { Order } from '../common/typings';
import { UploadCreative } from '../Html5Upload/typings';

import { Html5Page } from './typings';

export const changePage = createCustomAction('@html5App/CHANGE_PAGE', type => {
    return (page: Html5Page) => ({ type, page });
});

export type Html5AppAction = ReturnType<typeof changePage>;

export const loadItems = createCustomAction('@html5Creatives/LOAD_ITEMS', type => {
    return (offset: number, order: Order, sizes: string[], filterText: string) => ({
        type,
        offset,
        order,
        sizes,
        filterText
    });
});
export const loadItemsSuccess = createCustomAction('@html5Creatives/LOAD_ITEMS_SUCCESS', type => {
    return (collection: BatchesCollection, sizes: string[]) => ({
        type,
        collection,
        sizes
    });
});
export const applySizesFilter = createCustomAction('@html5Creatives/APPLY_SIZES_FILTER', type => {
    return (sizes: string[]) => ({ type, sizes });
});
export const showError = createCustomAction('@html5Creatives/SHOW_ERROR', type => {
    return (message: string) => ({ type, message });
});
export const hideError = createCustomAction('@html5Creatives/HIDE_ERROR');
export const setSelection = createCustomAction('@html5Creatives/SET_SELECTION', type => {
    return (id: string, selected: boolean) => ({ type, id, selected });
});
export const saveName = createCustomAction('@html5Creatives/SAVE_NAME', type => {
    return (id: string, val: string) => ({ type, id, val });
});
export const saveNameSuccess = createCustomAction('@html5Creatives/SAVE_NAME_SUCCESS', type => {
    return (id: string, val: string) => ({ id, val, type });
});
export const deleteCreative = createCustomAction('@html5Creatives/DELETE_CREATIVE');
export const deleteCreativeSuccess = createCustomAction('@html5Creatives/DELETE_CREATIVE_SUCCESS', type => {
    return (id: string) => ({ id, type });
});
export const showDeleteConfirm = createCustomAction('@html5Creatives/SHOW_DELETE_CONFIRM', type => {
    return (id: string) => ({ type, id });
});
export const hideDeleteConfirm = createCustomAction('@html5Creatives/HIDE_DELETE_CONFIRM');
export const showCreativesSelector = createCustomAction('@html5Creatives/SHOW_CREATIVES_SELECTOR', type => {
    return (id: string) => ({ type, id });
});
export const hideCreativesSelector = createCustomAction('@html5Creatives/HIDE_CREATIVES_SELECTOR');
export const toggleSizesSelection = createCustomAction('@html5Creatives/TOGGLE_SIZES_SELECTION', type => {
    return (ids: number[], selected: boolean) => ({ type, ids, selected });
});
export const submitSizesSelection = createCustomAction('@html5Creatives/SUBMIT_SIZES_SELECTION');
export const submit = createCustomAction('@html5Creatives/SUBMIT', type => {
    return (callback: (ids: number[]) => void) => ({ type, callback });
});
export const hideBusy = createCustomAction('@html5Creatives/HIDE_BUSY');
export type Submit = ReturnType<typeof submit>;
export type LoadItems = ReturnType<typeof loadItems>;
export type SaveName = ReturnType<typeof saveName>;
export type DeleteCreative = ReturnType<typeof deleteCreative>;

export type Html5CreativesAction =
    | LoadItems
    | SaveName
    | DeleteCreative
    | Submit
    | ReturnType<typeof deleteCreativeSuccess>
    | ReturnType<typeof loadItemsSuccess>
    | ReturnType<typeof applySizesFilter>
    | ReturnType<typeof setSelection>
    | ReturnType<typeof showError>
    | ReturnType<typeof hideError>
    | ReturnType<typeof saveNameSuccess>
    | ReturnType<typeof showDeleteConfirm>
    | ReturnType<typeof hideDeleteConfirm>
    | ReturnType<typeof showCreativesSelector>
    | ReturnType<typeof hideCreativesSelector>
    | ReturnType<typeof toggleSizesSelection>
    | ReturnType<typeof submitSizesSelection>
    | ReturnType<typeof hideBusy>;

export const createCreative = createCustomAction('@html5Upload/CREATE_CREATIVE');
export const createCreativeSuccess = createCustomAction('@html5Upload/CREATE_CREATIVE_SUCCESS');
export const cancelCreation = createCustomAction('@html5Upload/CANCEL_CREATION');
export const upload = createCustomAction('@html5Upload/UPLOAD', type => (creatives: UploadCreative[]) => ({
    type,
    creatives
}));
export type Html5Upload = ReturnType<typeof upload>;
export const uploadFinished = createCustomAction(
    '@html5Upload/UPLOAD_FINISHED',
    type => (creative: UploadCreative) => ({ type, creative })
);
export const uploadCancelled = createCustomAction(
    '@html5Upload/UPLOAD_CANCELLED',
    type => (creative: UploadCreative) => ({ type, creative })
);
export const saveUploadName = createCustomAction('@html5Upload/SAVE_UPLOAD_NAME', type => (name: string) => ({
    type,
    name
}));

export type Html5UploadAction =
    | ReturnType<typeof cancelCreation>
    | ReturnType<typeof uploadFinished>
    | ReturnType<typeof uploadCancelled>
    | ReturnType<typeof saveUploadName>
    | ReturnType<typeof createCreative>
    | ReturnType<typeof createCreativeSuccess>
    | Html5Upload;
